module.exports = __webpack_public_path__ + "static/media/prter.be30e5c1.png";